import type {
  CardView,
  PillCategories,
  TicketFilterState,
} from 'features/libra/dashboard/ticketDashboard/types'
import { useCallback, useMemo, useState } from 'react'

import { applyFilters } from './applyFilters'
import { buildCardIndex } from './cardIndex'

const EMPTY_FILTER_STATE: TicketFilterState = { query: '', selection: {} }

export function useTicketFilters(
  cards: ReadonlyArray<CardView>,
  categories: PillCategories
) {
  const [state, setState] = useState(EMPTY_FILTER_STATE)

  const index = useMemo(() => buildCardIndex(cards), [cards])
  const { visibleRows, filters } = useMemo(
    () => applyFilters(index, categories, state),
    [index, categories, state]
  )

  const setQuery = useCallback(
    (query: string) => setState((prev) => ({ ...prev, query })),
    []
  )
  const setCategoryValues = useCallback(
    (category: string, values: ReadonlyArray<string>) =>
      setState((prev) => ({
        ...prev,
        selection: { ...prev.selection, [category]: values },
      })),
    []
  )

  return { state, filters, visibleRows, setQuery, setCategoryValues }
}
